import type { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import { trackEvent } from 'analytics/analytics'
import {
  aiOfferDescriptionClickEventWithContext,
  aiOfferDescriptionImpressionEventWithContext,
} from 'analytics/snowplow/events'
import {
  OfferListEvents,
  type OfferListEventsDispatchAction,
} from 'components/OfferList/OfferListEventsContext'

type AiOfferDescriptionTrackingData = {
  searchContext: App.SearchContext
  filterContexts: Array<comluxgroup.Filter_1_0_0>
  sortContext?: comluxgroup.Sort_1_0_0
  searchSessionId: string
}

export function trackAiOfferDescriptionListEvent(
  dispatchAction: OfferListEventsDispatchAction,
  tracking: { listName: string, listId: string },
  additionalData: AiOfferDescriptionTrackingData,
) {
  if (
    dispatchAction.type !== OfferListEvents.aiDescriptionClick &&
    dispatchAction.type !== OfferListEvents.aiDescriptionImpression
  ) {
    return
  }

  const buildEvent = dispatchAction.type === OfferListEvents.aiDescriptionClick
    ? aiOfferDescriptionClickEventWithContext
    : aiOfferDescriptionImpressionEventWithContext

  trackEvent(buildEvent(
    dispatchAction.position + 1,
    tracking.listName,
    tracking.listId,
    dispatchAction.offer,
    additionalData,
  ))
}
